import { IsOptional, IsString } from 'class-validator';

export class HtmlConfigDto {
    @IsOptional()
    @IsString()
    htmlWrapper?: string;
}

